import React from "react";
import { Loader2, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../../../shadcn/ui/dialog";

const DeleteOrganizationModal = ({ isOpen, onClose, organizationToDelete, deleteOrganizationLoading, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto bg-white rounded-lg border border-gray-200 p-0">
        <div className="p-6">
          <div className="mb-6">
            <DialogTitle className="text-xl font-semibold text-gray-900 mb-2">Delete Organization</DialogTitle>
            <p className="text-sm text-gray-500">This action cannot be undone</p>
          </div>

          <div className="space-y-6 max-h-[60vh] overflow-y-auto">
            {organizationToDelete && (
              <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
                <h4 className="text-sm font-medium text-gray-800 mb-2">Organization to be deleted:</h4>
                <p className="text-sm text-gray-700 font-medium">{organizationToDelete.name}</p>
                <p className="text-xs text-gray-500">Code: {organizationToDelete.code}</p>
                <p className="text-xs text-gray-500">Contact: {organizationToDelete.contactEmail}</p>
                <p className="text-xs text-gray-500">Status: {organizationToDelete.status}</p>
              </div>
            )}

            <div className="flex items-center space-x-3 mb-4">
              <AlertTriangle className="h-6 w-6 text-red-500 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-red-800">This action cannot be undone!</p>
                <p className="text-sm text-red-700">
                  Are you sure you want to delete this organization? This will permanently disable the organization and
                  all associated data will become inaccessible.
                </p>
                <p className="mt-2 text-xs text-red-600">
                  <strong>Warning:</strong> All users associated with this organization will lose access to their
                  accounts.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-2 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
            disabled={deleteOrganizationLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleteOrganizationLoading}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {deleteOrganizationLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            {deleteOrganizationLoading ? "Deleting..." : "Delete Organization"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteOrganizationModal;
